/***
 * @file: æç´¢ç»ä»¶
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { SettingsService } from '@ithinkdt/shared/browser';
import { DictionaryService } from '@ithinkdt/shared/dict';
import { DtMessageService } from '@ithinkdt/shared/message';
import { deleteEmptyObj } from '@ithinkdt/shared/utils';
import { cloneDeep, isEmpty, trim } from 'lodash';

import { deleteSpecialCharacter } from '../form.utils';
import { isSpecialCharacter } from '../validate';
import { DtValidators } from '../validators';

/**
 * æç´¢è¡¨åæ§ä»¶
 * æ¯æä¸ç§æ§ä»¶ï¼
 * - input
 * - select
 * - date
 * - dateRange
 * - time
 *
 * @param labelWidth æ§ä»¶åç§°å¤§å°ï¼ä¼ å¥æ éå¸¦`px`
 * @param colNumber ä¸è¡æ¾ç¤ºå ä¸ªæ§ä»¶ãå¯ä»¥è¢«24æ´é¤çæ­£æ´æ°
 * @param searchItems ä¼ å¥è¡¨åæ°æ®ï¼å®æå¦ä¸åå®¹ï¼
 * - type: input | select |  date | dateRange | time
 * - lable: é®å
 * - value: æ¾ç¤ºçæ§ä»¶åç§°
 * - width: æ§ä»¶åç§°å¤§å°,å¯éçï¼ä¸ä¼ åé»è®¤100px
 * - options: ç±»åä¸º`select`æ¶æ¹éä¼ å¥æ­¤æ°æ®ï¼ä¸æçå¼ã
 * - keys: ç±»åä¸º`dateRange`æ¶,è¾åºçå¼å§æ¥æåç»ææ¥æçå±æ§å
 * @example
 * searchItems:
 * ```
 * [
 *  {
 *    type: "input",
 *    label: "name",
 *    value: "åç§°"
 *  },
 *  {
 *    type: "date",
 *    label: "birthday",
 *    value: "çæ¥"
 *  },
 *  {
 *    type: "select",
 *    label: "sex",
 *    value: "æ§å«",
 *    options: [
 *      {
 *        label: "man",
 *        value: "ç·"
 *      },
 *      {
 *        label: "woman",
 *        value: "å¥³"
 *      }
 *  },
 *  {
 *    type: 'dateRange',
 *    label: 'sendDate',
 *    value: 'æ¥æèå´',
 *    keys: ['startDate', 'endDate']
 *  },
 *  {
 *    type: 'time',
 *    label: 'sendTime',
 *    value: 'æ¶é´éæ©'
 *  }
 * ]
 * ```
 * ç»ä»¶è°ç¨:
 * ```
 * <dt-form-search [operable]="false" [underline]="false" [searchItems]="searchItems" [colNumber]="6" [lableWidth]="100" (formSearch)="search($event)"></dt-form-search>
 * ```
 * @return formSearch æç´¢åè°å½æ°ï¼æè¾å¥çæ°æ®ä»¥keyä¸º`label`çjsonå¯¹è±¡ä¼ åç¶ç»ä»¶ã
 * @return resetSearchForm éç½®åè°å½æ°ï¼éç½®çæ¶åä¼å¨æç´¢çåè°å½æ°ä¸­åæ¬¡è¯·æ±æ°æ®ã
 * @author linkun.he
 */

@Component({
  selector: 'dt-form-search',
  templateUrl: './form-search.component.html',
  styleUrls: ['./form-search.component.scss'],
})
export class FormSearchComponent implements OnChanges {
  /**
   * formè¡¨å
   */
  validateForm: FormGroup;
  /**
   * æ¥ææ ¼å¼åå¸¸é
   */
  dateFormat = 'yyyy/MM/dd';
  /**
   * å®éæ¾ç¤ºçè¡¨åæ§ä»¶éå
   */

  showItems: any;
  /**
   * é»è®¤ä¸ä¸ªæ§ä»¶å®½åº¦
   */
  itemSize = 8;
  /**
   * å­å¸éç½®
   */
  dictConfig;
  /**
   * æ¯å¦æ¾ç¤ºæå æé®
   */
  @Input() showCollapse = true;
  /**
   * æ¯å¦æ¾ç¤ºæé®é£ä¸è¡
   */
  @Input() hideBtnRow = false;
  /**
   * æ¯å¦æ¾ç¤ºæé®é£ä¸è¡
   */
  @Input() searchByReset = true;
  /**
   * åç§°é¿åº¦
   */
  @Input() labelWidth = '100';
  /**
   * æ¯å¦å¯ä»¥ç¼è¾
   */
  @Input() operable = false;
  /**
   * æ¯å¦æå 
   */
  @Input() isCollapse = true;
  /**
   * æ¯å¦æ¾ç¤ºä¸åçº¿
   */
  @Input() underline = false;
  /**
   * ä¸è¡æ¾ç¤ºå ä¸ª
   */
  @Input() colNumber = 3;
  /**
   * ä¼ å¥çæç´¢é¡¹
   */
  @Input() searchItems;
  /**
   * ä¼ å¥çæç´¢è¡¨å
   */
  @Input() searchForm;
  /**
   * åè°å½æ°
   * ææ§ä»¶è¾å¥çå¼ä¼ åè°ç¨ç»ä»¶ï¼è¥æ å¼åä¸ä¼ éã
   */
  @Output()
  formSearch = new EventEmitter<any>();
  @Output()
  resetSearchForm = new EventEmitter<any>();

  constructor(
    private fb: FormBuilder,
    private messageSrv: DtMessageService,
    private dictionarySrv: DictionaryService,
    private settingsSrv: SettingsService
  ) {
    this.dictConfig = this.settingsSrv.userConfig['pages'] || {};
  }

  ngOnChanges() {
    this.validateForm = this.searchForm ? this.searchForm : this.fb.group({});
    this.initTemp();
    this.getLabelSize();
    this.initSearchData();
    this.createForm();
  }

  initTemp() {
    if (this.searchItems) {
      this.showItems = cloneDeep(this.searchItems);

      // è®¾ç½®ä¸ææ°æ®
      this.showItems.forEach((item) => {
        if (item.dictCode) {
          this.dictionarySrv.getDicListByDicCode(item.dictCode).subscribe((res: any) => {
            item.requestOptions = res.data;
          });
        }
      });
    }
    if (!this.showCollapse) {
      this.isCollapse = false;
    }
  }

  // è·ålabelé¿åº¦
  getLabelSize() {
    this.itemSize = Math.floor(24 / this.colNumber);
  }

  // æ ¼å¼åä¼ å¥çæç´¢æ°æ®
  initSearchData() {
    this.searchItems.forEach((item) => {
      item.checked = true;
    });
  }

  // æå»ºform
  createForm() {
    this.showItems.forEach((item) => {
      item.validators = [];
      if (item.required) {
        item.validators.push(DtValidators.required);
      }
      if (item.minLength) {
        item.validators.push(DtValidators.minLength(item.minLength));
      }
      if (item.maxLength) {
        item.validators.push(DtValidators.maxLength(item.maxLength));
      }
      this.addFormControl(item.label, item.defaultValue, item.validators);
    });
  }

  /**
   * æç´¢
   * @param formData è¡¨åæ°æ®
   */
  search(formData) {
    const _this = this;
    for (const i in this.validateForm.controls) {
      // å»é¤ååç©ºæ ¼
      let val = this.validateForm.controls[i].value;

      if (typeof val === 'string') {
        val = trim(val);
        this.validateForm.controls[i].setValue(val);
      }

      this.validateForm.controls[i].markAsDirty();
      this.validateForm.controls[i].updateValueAndValidity();
    }
    if (this.validateForm.valid) {
      const formValue = deleteEmptyObj(formData.value);
      this.searchItems.forEach((item) => {
        if (formValue[item.label] === undefined) {
          return;
        }
        switch (item.type) {
          case 'dateRange':
            try {
              if (!isEmpty(formValue[item.label])) {
                formValue[item.keys[0]] = formValue[item.label][0].getTime();
                formValue[item.keys[1]] = formValue[item.label][1].getTime();
              }
              delete formValue[item.label];
              break;
            } catch {}

          case 'date':
          case 'time':
            try {
              formValue[item.label] = formValue[item.label].getTime();
            } catch {}
            break;
          case 'checkbox':
            try {
              formValue[item.label] = formValue[item.label].filter((t) => t.checked);
              if (!formValue[item.label].length) {
                delete formValue[item.label];
              } else {
                formValue[item.label] = formValue[item.label].map((t) => t.label);
              }
              break;
            } catch {}
          default:
            break;
        }
      });
      this.formSearch.emit(formValue);
    } else {
      // åé¢åå½éå
      this.messageSrv.error('operations.fill.mustFill');
    }
  }

  // æé®æå 
  toggleCollapse() {
    this.isCollapse = !this.isCollapse;
  }

  // checkBoxåè°
  onChoose(choosedItems) {
    this.showItems = choosedItems;
    this.createForm();
  }

  // inputæ¡è¾å¥äºä»¶
  onInput(item, event) {
    // éç½®æ¯å¦éè¦è¿æ»¤ç¹æ®å­ç¬¦
    if (!item.notSpecialCharacter) {
      return;
    }
    if (isSpecialCharacter(event.data)) {
      const result = deleteSpecialCharacter(event.target.value);
      event.target.value = result;
      this.validateForm.get(item.label).setValue(result);
    }
  }

  // æ°å¢è¡¨åæ§ä»¶
  // addFormControl(label, require?) {
  //   let formCtrl = null;
  //   formCtrl = require
  //     ? new FormControl(null, Validators.required)
  //     : formCtrl = new FormControl();
  //   this.validateForm.addControl(label, formCtrl);
  // }

  // æ°å¢è¡¨åæ§ä»¶
  addFormControl(label, defaultValue = null, validators?) {
    this.validateForm.addControl(label, new FormControl(defaultValue, validators));
  }

  // éç½®è¡¨å
  resetForm(): void {
    this.validateForm.reset();
    this.resetSearchForm.emit();
    if (!this.searchByReset) {
      return;
    }
    this.formSearch.emit({});
  }
}
